export default function Hero() {
  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToPortfolio = () => {
    const el = document.getElementById('portfolio');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/4b0fab2e26826e46acc6c00c4ae51403.jpg"
          alt="Retail Store Interior with Extensive Track Lighting"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center max-w-5xl mx-auto px-6">
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-light text-white mb-8 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
          Mount Zion Investment INC
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto font-light">
          Transforming Commercial & Residential Spaces with Excellence Since 1998
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => scrollToContact()}
            className="px-8 py-4 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-base font-semibold rounded-full hover:from-amber-600 hover:to-orange-600 transition-all shadow-xl whitespace-nowrap cursor-pointer"
          >
            Get Free Estimate
          </button>
          <button
            onClick={() => scrollToPortfolio()}
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-base font-semibold rounded-full hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap cursor-pointer"
          >
            View Our Work
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/70"></i>
      </div>
    </section>
  );
}
